import { useCallback } from "react";
import { useIntl } from "react-intl";
import { IResponseEventsLog } from "../pages/dashboard/tabs/scheme/components/events-train/interfaces";

export interface IGetEventTypeProps {
  type?: number;
  subType?: number;
}

export interface IUseEventTypeReturn {
  getEventType: (data: IGetEventTypeProps) => string;
  getMessage: (item: IResponseEventsLog) => string;
}

export const useEventType = (): IUseEventTypeReturn => {
  const { formatMessage } = useIntl();

  const isServiceEvent = (item?: IResponseEventsLog) => !!item && item.EventType === 4 && item.EventSubType === 2;

  const getMessage = useCallback(
    (item: IResponseEventsLog) => {
      if (isServiceEvent(item)) {
        return `${item.Flags === 0 ? "Нет соединения." : "Соединение восстановлено."} Устройство ${item.DeviceName}${
          item.idPoint ? `, точка ${item.PointName}` : ""
        }`;
      }

      const value1 = Number(item.DataValue1);
      const value1Str = Number.isFinite(value1) ? value1.toFixed(2) : "-";
      const unitsKey = item.MeasureUnits != null ? `enums.units.${item.MeasureUnits}` : "enums.units.0";
      const alarmLevel =
        item.MeasureAlarmLevel != null && Number.isFinite(Number(item.MeasureAlarmLevel))
          ? Number(item.MeasureAlarmLevel).toFixed(2)
          : "-";

      return `${value1Str} ${formatMessage({ id: unitsKey })} (${
        item.MeasureAlarmType === 1 ? `По превышению ${item.MeasureName ?? ""}` : `${item.MeasureName ?? ""}`
      }; норма ${alarmLevel})`;
    },
    [formatMessage, isServiceEvent],
  );

  const getEventType = useCallback(
    ({ type, subType }: IGetEventTypeProps): string => {
      if (type && subType) {
        return `${formatMessage({ id: `enums.eventType.${type}`, defaultMessage: "-" })} / ${formatMessage({
          id: `enums.eventSubType.${subType}`,
          defaultMessage: "-",
        })}`;
      }

      if (type && !subType) {
        return formatMessage({ id: `enums.eventType.${type}`, defaultMessage: "-" });
      }

      if (!type && subType) {
        return formatMessage({ id: `enums.eventSubType.${subType}`, defaultMessage: "-" });
      }

      return "-";
    },
    [formatMessage],
  );

  return { getEventType, getMessage };
};
